/**
 * Brand Showcase — Carousel
 * Arrows + optional auto-scroll. Hover pauses auto-scroll.
 */
(function () {
  function init(container) {
    var wrap = container.querySelector('.ode-bs__carousel-wrap');
    var carousel = container.querySelector('.ode-bs__carousel');
    var prevBtn = container.querySelector('.ode-bs__arrow--prev');
    var nextBtn = container.querySelector('.ode-bs__arrow--next');

    if (!carousel) return;

    var autoScroll = wrap && wrap.dataset.autoScroll === 'true';
    var scrollSpeed = parseFloat((wrap && wrap.dataset.scrollSpeed) || '4') * 1000;
    var autoScrollInterval = null;
    var isPaused = false;

    function getItemWidth() {
      var item = carousel.querySelector('.ode-bs__item');
      if (!item) return 168;
      return item.offsetWidth + 48; // 48px gap
    }

    function updateArrows() {
      if (!prevBtn || !nextBtn) return;
      var scrollLeft = Math.round(carousel.scrollLeft);
      var maxScroll = carousel.scrollWidth - carousel.clientWidth;
      prevBtn.disabled = scrollLeft <= 2;
      nextBtn.disabled = scrollLeft >= maxScroll - 2;
    }

    function scrollBy(direction) {
      carousel.scrollBy({ left: getItemWidth() * direction, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () { scrollBy(-1); });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () { scrollBy(1); });
    }

    carousel.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    // Auto-scroll
    if (autoScroll && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      container.addEventListener('mouseenter', function () { isPaused = true; });
      container.addEventListener('mouseleave', function () { isPaused = false; });

      autoScrollInterval = setInterval(function () {
        if (isPaused) return;
        var scrollLeft = Math.round(carousel.scrollLeft);
        var maxScroll = carousel.scrollWidth - carousel.clientWidth;
        if (scrollLeft >= maxScroll - 2) {
          carousel.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollBy(1);
        }
      }, scrollSpeed);
    }
  }

  function ready() {
    var sections = document.querySelectorAll('.ode-bs--carousel');
    sections.forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
